export const stringArrayToObject = stringArray => {
  if (stringArray.some(element => !element || typeof element !== 'string')) {
    throw new Error('Array elements must be strings and must not be empty')
  }
  return stringArray.reduce((obj, stringElement) => ({ ...obj, [stringElement]: stringElement }), {})
}

export const getElementById = (elements, id) => elements.find(elem => elem.id === id)

export const getArrayOfIntFromQueryParams = (filter, field) => {
  if (filter[field]) {
    if (Array.isArray(filter[field])) return filter[field].map(el => parseInt(el))
    else if (!isNaN(filter[field])) return [parseInt(filter[field])]
  }
  return null
}
